import React, { useEffect, useState } from 'react';
import {
  about5, heroVideo, arashBg, aboutBg,
  subMenuProjects, subMenuHome, subMenuPartners, projectsBg
} from '../../assets/images';
import Header from '../../Components/Header/Header';
import ProjectDetailItems from './ProjectDetailItems/ProjectDetailItems';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Breadcrumb from '../../Components/Breadcrumb/Breadcrumb';

const ProjectDetail = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();

  const [news, setNews] = useState([]);
  const [singleNews, setSingleNews] = useState(null);

  const currentLanguage = i18n.language || 'az';

  const getLocalizedField = (item, fieldBase) => {
    if (!item) return "";
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase];
  };

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://cortex-site.runasp.net/api/Projects`,
        { withCredentials: false }
      );
      const data = response.data;
      setNews(data);

      const filtered = data.find(product => product.id == id);
      setSingleNews(filtered || null);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  return (
    <>
        <Breadcrumb
          title={t("Layihələr")}
          content={getLocalizedField(singleNews, "title")}
        />

      <ProjectDetailItems />
    </>
  );
};

export default ProjectDetail;
